import { render, staticRenderFns } from "./HeaderUsers.vue?vue&type=template&id=2d7ba0c1&scoped=true&"
import script from "./HeaderUsers.vue?vue&type=script&lang=js&"
export * from "./HeaderUsers.vue?vue&type=script&lang=js&"
import style0 from "./HeaderUsers.vue?vue&type=style&index=0&id=2d7ba0c1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7ba0c1",
  null
  
)

export default component.exports